import type { VendorDataSource } from '~/api/data-source/vendor';
import { vendorDataSource } from '~/api/data-source/vendor';
import type { MarketProductVendor, VendorDisplay } from '~/api/model';
import {
  marketProductVendorSchema,
  parseModel,
  vendorDisplaySchema,
} from '~/api/model';

export interface VendorRepository {
  getVendor(vendorId: number): Promise<MarketProductVendor>;
  getVendorDisplay(vendorId: number): Promise<VendorDisplay>;
}

export class VendorRepositoryImpl implements VendorRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: VendorDataSource = vendorDataSource,
  ) {}

  async getVendor(vendorId: number) {
    const response = await this.dataSource.getVendor(vendorId);
    return parseModel(
      marketProductVendorSchema,
      response,
      'MarketProductVendor',
    );
  }

  async getVendorDisplay(vendorId: number) {
    const response = await this.dataSource.getVendorDisplay(vendorId);
    return parseModel(vendorDisplaySchema, response, 'VendorDisplay');
  }
}

export const vendorRepository = new VendorRepositoryImpl();
